import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectDailyWheel,
  selectDailyWheelAvailableAtStatus,
  selectDailyWheelStatus,
} from '../state';
import { isUserOnBreak } from '@bonanza-social/account';
import { useMemo } from 'react';

const useDailyWheel = () => {
  const dailyWheel = useSelector(selectDailyWheel);
  const dailyWheelStatus = useSelector(selectDailyWheelStatus);
  const dailyWheelAvailableAtStatus = useSelector(
    selectDailyWheelAvailableAtStatus,
  );
  // TODO: Uncomment for ESB Wheel
  // const dailyWheelIsMetaGame = useSelector(selectDailyWheelIsMetaGame);
  const dailyWheelIsMetaGame = false;
  const isUserTimedOut = useSelector(isUserOnBreak);
  const isVisible = useMemo(
    () => dailyWheel && !isUserTimedOut,
    [dailyWheel, isUserTimedOut],
  );

  return {
    dailyWheel,
    dailyWheelStatus,
    dailyWheelAvailableAtStatus: dailyWheelAvailableAtStatus ?? 'Amethyst',
    isVisible,
    dailyWheelIsMetaGame,
  };
};

export default useDailyWheel;
